<template>
  <div v-if="analysis" class="grid w-full grid-cols-1 gap-8">
    <div class="flex w-full flex-col gap-8 pb-10 md:gap-4">
      <QuestionHistogram
        v-for="question in analysis.questions"
        :key="question.question.id"
        :data="question"
        :topic-perspectives="topicPerspectives"
        :disable-animation="true"
      />
      <div v-if="analysis.texts.length > 0">
        <PrintFinalTextFeedbacks :texts="analysis.texts" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { PulseAnalysis } from '@/core/models/surveys-analytics'
  import type { Perspective } from '@/core/models/perspective'
  import { perspectivesFromTopic } from '@/core/models/perspective'
  import PrintFinalTextFeedbacks from '@/modules/dialog/components/print/PrintFinalTextFeedbacks.vue'
  import QuestionHistogram from '@/core/components/analytics/question-histogram/QuestionHistogram.vue'

  interface Props {
    feedbackTopic: {
      id: string
      title: string
      icon: string
      perspectives: ReadonlyArray<Perspective>
      includeSelf: boolean
    }
    analysis: PulseAnalysis
  }

  const props = defineProps<Props>()
  const topicPerspectives = computed(() => perspectivesFromTopic(props.feedbackTopic))
</script>
